// extracted by mini-css-extract-plugin
module.exports = {"titleTooltip":"FloatingTooltip-moduletitleTooltip3Q-"};